import mapboxgl, { LngLat, Map } from "mapbox-gl"
import React, { useEffect, useRef, useState } from "react"
import { zoomForCoordinates } from "../../models/MapBoxDataModel"
import { addPolygonGroupFeature, updatePolygonGroup } from "../../models/MapBoxGroupModel"
import { GroupModel } from "../../models/organisation/GroupModel"
import { GroupCard } from "./GroupCard"
import { t } from "i18next"
import { colorGrey } from "../../rsc/colors/colors"


type Props = {
  style: React.CSSProperties
  groups: GroupModel[]
}

export function CompanyGroup({ style, groups }: Props) {

  const [groupSelected, setGroupSelected] = useState<GroupModel>(groups[0])

  const mapRef = useRef<Map>()

  mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  useEffect(() => {
    if (mapRef.current) return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    mapRef.current = new mapboxgl.Map({
      container: `mapGroup`,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [0, 0],
      zoom: 13
    });
    mapRef.current.on("load", () => {
      addPolygonGroupFeature(mapRef.current, groupSelected.plots)
      ChangeMapSize()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (mapRef.current && groupSelected) {
      updateMap(groupSelected)
    }
  }, [groupSelected])

  function updateMap(group: GroupModel) {
    updatePolygonGroup(mapRef.current, group.plots)
    const plotCoords = [...group.plots].flatMap(p => p.polygon ? p.polygon.coordinates[0].map(co => new LngLat(co[0], co[1])) : [])
    zoomForCoordinates(mapRef.current, plotCoords)
  }


  useEffect(() => {
    if (groupSelected) {
      const mapContainer = document.getElementById(`mapGroup-${groupSelected.id}`);
      const mapElement = document.getElementById(`mapGroup`);
      if (mapContainer && mapElement) {
        mapContainer.appendChild(mapElement); // Move the map into the selected group
      }
    }
  }, [groupSelected])

  const ChangeMapSize = () => {
    setTimeout(() => {
      mapRef.current.resize()
    }, 100)
  }

  return (
    <div hidden={false} style={{ ...style, display: groups ? "flex" : 'none', flexDirection: "column", gap: "1px" }}>
      <p className="greyColor" style={{ fontSize: "20px" }}>{t('groups')}</p>
      {/* <div id="groupMap"></div> */}
      <div style={{ display: "flex", gap: "15px", boxShadow: groupSelected ? "0px -2px 6px rgba(0, 0, 0, 0.05), 0px 4px 6px rgba(0, 0, 0, 0.10)" : "", marginTop: "10px" }}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: '10px',
          flex: 1
        }}>
          {
            groups.length === 0 && <p style={{fontWeight:600, fontStyle:'italic', color:colorGrey, marginTop:'10px'}}>No groups Created</p>
          }
          {
            groups?.map((g, i) => <GroupCard key={i} group={g}
              setGroupSelected={(g: GroupModel) => setGroupSelected(groupSelected && groupSelected?.id === g?.id ? undefined : g)}
              isOpen={groupSelected && groupSelected?.id === g?.id}
              map={mapRef.current} />)
          }
        </div>
      </div>
      <div style={{ width: '100%', height: 0, position:"relative" }}>
        <div id="mapGroup" style={{ width: "100%", height: "100%" }}></div>
      </div>
    </div>
  )
}